import { ATFooter } from "../../components/at-footer/at-footer";
import { ATHeader } from "../../components/at-header/at-header";
export const layoutOptions = {
  HeaderComponent: ATHeader,
  FooterComponent: ATFooter,
  mainClassName: "used-fpa",
};
